var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSovcombank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 68.7156C0 106.891 30.8874 137.431 68.7156 137.431C69.7569 137.431 70.4508 137.431 71.492 137.431V111.402L68.7156 111.403C45.1162 111.403 26.0285 92.315 26.0285 68.7156C26.0285 45.1162 45.1162 26.0285 68.7156 26.0285H71.492V0C70.4508 0 69.7569 0 68.7156 0C30.8874 0 0 30.8871 0 68.7156Z",
    fill: "#FC5055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5974 1.38818V37.1342H68.7156C51.363 37.1342 37.1342 51.3634 37.1342 68.7156C37.1342 86.0681 51.3634 100.297 68.7156 100.297H82.5974V136.043C114.179 129.796 137.778 102.032 137.778 68.7156C137.779 35.3986 114.179 7.63499 82.5974 1.38818Z",
    fill: "#003790"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSovcombank);
export default __webpack_public_path__ + "static/media/sovcombank.78793594c0bcc967346a4e0d5ea2779b.svg";
export { ForwardRef as ReactComponent };